import { useNavigate, useRouteData } from "@solidjs/router"
import { onMount, Show } from "solid-js";
import { fetchGet } from "../library/common";
import toast from "solid-toast";
import { PageLoading } from "../components/page-loading";
import { createStore } from "solid-js/store";

type State = {
    isContentReady: boolean;
}

export function PaypalConfirmedPage() {
    const navigate = useNavigate();
    const [state, setState] = createStore<State>({ isContentReady: false });
    const concludePayment = async (paymentId: string) => {
        const res = await fetchGet("/SalonApplication/Salon/PaypalConfirmJson", { paymentId });
        const json = await res.json();
        if (!json.Success) {
            return toast.error(json.ErrorMessage);
        }
        navigate("/payment/processed");
    }
    onMount(async () => {
        const routeData = await useRouteData() as any;
        await concludePayment(routeData.paymentId);
        setState("isContentReady", true);
    });
    return (
        <>
            <Show when={state.isContentReady} fallback={<PageLoading />}>
                <div class="blank-page">
                    <h2>
                        Finalising the Paypal payment now ...
                    </h2>
                </div>
            </Show>
        </>
    );
}